import CallsToAciton from '@components/calls-to-action';
import ComponentRenderer from '@components/cms-components/component-renderer';
import TextBlock from '@components/text-block';
import { Yeseva } from 'app/fonts';
import type { ReactElement } from 'react';
import React from 'react';
import type { TextBlockData } from 'types/components/text-block';
import type { DataProps } from 'types/props/data-props';

export default function TextBlockComponent({
  context,
  description,
  eyebrow,
  heading,
  layout = 'left',
  subHeading,
  primaryCta,
  secondaryCta,
  theme,
}: Readonly<DataProps<TextBlockData>>): ReactElement {
  return (
    <TextBlock
      callsToAction={
        <CallsToAciton
          primaryCta={primaryCta}
          secondaryCta={secondaryCta}
          theme={theme}
        />
      }
      description={
        <ComponentRenderer context={context}>{description}</ComponentRenderer>
      }
      eyebrow={eyebrow}
      heading={<h2 className={Yeseva.className}>{heading}</h2>}
      layout={layout}
      subHeading={subHeading}
      theme={theme}
    />
  );
}
